import 'bootstrap'

import { createApp } from 'vue'

import App from '@/main/App.vue'
import router from '@/main/router'

import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client/core'
import { createApolloProvider } from '@vue/apollo-option'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faCalendarAlt)

const HOST = 'https://app.birdweather.com'

const httpLink = new HttpLink({
  uri: `${HOST}/graphql`
})

const cache = new InMemoryCache()

const apolloClient = new ApolloClient({
  link: httpLink,
  cache
})

const apolloProvider = createApolloProvider({
  defaultClient: apolloClient,
})

document.addEventListener('DOMContentLoaded', () => {
  const appEl = document.getElementById('app')

  if (appEl) {
    const app = createApp(App)

    app.use(router)
    app.use(apolloProvider)

    app.component('font-awesome-icon', FontAwesomeIcon)

    app.mount(appEl)
  }
})
